export const EMastraAgentId = {
  OrchestratorAgent: "OrchestratorAgent",
  PayrollSpecialistAgent: "PayrollSpecialistAgent",
  HrSpecialistAgent: "HrSpecialistAgent",
  ReportingSpecialistAgent: "ReportingSpecialistAgent",
} as const;

export type TMastraAgentId =
  (typeof EMastraAgentId)[keyof typeof EMastraAgentId];
